var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg20ColoredClaiLogo = function Svg20ColoredClaiLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h20v20H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#20-colored-clai-logo_svg__a)",
    d: "M7.277 9.58c.806 0 1.459.653 1.46 1.458v6.493c0 .26-.21.469-.47.469H6.38A4.38 4.38 0 0 1 2 13.621V10.05c0-.259.21-.469.468-.469zm10.253 1.684c.26 0 .469.21.469.467v1.89a4.38 4.38 0 0 1-4.38 4.378h-3.572a.47.47 0 0 1-.468-.468v-4.81c0-.805.653-1.457 1.458-1.457zM13.62 2a4.38 4.38 0 0 1 4.378 4.38V9.95c0 .259-.21.469-.468.469h-4.81a1.46 1.46 0 0 1-1.458-1.458V2.469A.47.47 0 0 1 11.73 2zm-3.668.001c.259 0 .469.21.469.469v4.808c0 .806-.653 1.46-1.458 1.46H2.47A.47.47 0 0 1 2 8.267V6.38A4.38 4.38 0 0 1 6.38 2z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "20-colored-clai-logo_svg__a",
    x1: 6,
    x2: 15,
    y1: 2,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3ED19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70FFEE"
  })))));
};
export default Svg20ColoredClaiLogo;